import wixWindow from 'wix-window';
import wixData from 'wix-data';
import wixLocation from 'wix-location';
import { sendEmail } from 'backend/sendEmail';

//-------------Filter data to show clicked item------------
$w.onReady(function () {
	let received = wixWindow.lightbox.getContext();
	let producuID = received.productIDsend;
	$w("#dataset1").setFilter(wixData.filter()
		.eq("_id", producuID)
	);
	newInquiry();
});

//--------------Inquiry number----------------------------
function newInquiry() {
	wixData.query("inquiries")
		.limit(1)
		.descending('_createdDate') // descending() sorts the results in descending order by property, i choose "_createdDate"
		.find()
		.then((results) => {
			const lastItemInCollection = results.items[0];
			let inquieryNumber = `${Number(lastItemInCollection.title) + 1}`
			$w('#inquieryNumber').text = inquieryNumber.toString();
		});
}
//--------------Send------------------------------------
export function sendBTN_click(event) {
	//Validate
	if ($w('#name').value === "") {
		$w('#error').show();
	} else {
		if ($w('#phone').value === "") {
			$w('#error').show();
		} else {
			if ($w('#email').value === "") {
				$w('#error').show();
			} else {
				$w('#infoBox').hide();
				$w('#thankyouBox').show();
				//email(); //canceled we use trigered emails
				insertToData();
			}
		}
	}
}

//--------------close----------------------------
export function close_click(event) {
	wixWindow.lightbox.close();
}
//--------------Insert to database-----------------------------------
function insertToData() {
	let current = $w('#dataset1').getCurrentItem();
	let imageSrc = current.image;
	console.log(imageSrc)
	let toInsert = {
		"title": $w('#inquieryNumber').text,
		"productName": $w('#productName').text,
		"productImage": imageSrc,
		"contactName": $w('#name').value,
		"contactPhone": $w('#phone').value,
		"contactEmail": $w('#email').value,
		"serialNumber": $w('#serialNumber').text,
		"textMessege": $w('#messege').value
	};

	wixData.insert("inquiries", toInsert)
		.then((results) => {
			console.log("data inserted")
			let item = results;
		})
		.catch((err) => {
			let errorMsg = err;
		});
}

//--------------Send email-----------------------------------
function email() {
	let url = "https://www.shibuzim.co.il//inquiries/" + $w('#inquieryNumber').text;
	console.log(url)
	let sender = "shibuzim@zahav.net.il";
	let recepient = "glaserbenny@gmail.com";
	const subject = `התענינות במוצר   ${$w('#productName').text}`;
	const body = `שם מלא:  ${$w('#name').value}
	\r טלפון: ${$w('#phone').value}
	\r אימייל: ${$w('#email').value}
	\r התעניין ב: ${$w('#productName').text}
	\r מספר סידורי: ${$w('#serialNumber').text}
	\r למידע המלא: ${url}
`;
	sendEmail(recepient, subject, sender, body)
		.then((res) => {
			console.log(res)
			console.log("sent email")
		})

		.catch((error) => {
			console.log(error)
		})
}